import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import ProfileContext from "../ProfileContext";
import { PAGE_STATE } from "../../../constants";
import useCollections from "../../../hooks/useCollections";
import useWorks from "../../../hooks/useWorks";
import _ from "lodash";
import ContentLoader from "react-content-loader";

const List = ({ onView }) => {
  const { user } = useContext(ProfileContext);
  const { queryCollectionByUserId } = useCollections();
  const [collections, setCollections] = useState(undefined);
  const [pageState, setPageState] = useState(PAGE_STATE.LOADING);
  const { queryWorks } = useWorks();

  useEffect(() => {
    fetchData();
  }, [user]);

  const fetchData = async () => {
    const { data: _collections } = await queryCollectionByUserId(
      user._id,
      {},
      null,
      -1,
      { works: 1, name: 1 }
    );

    let workIds = [];

    for (const collection of _collections) {
      workIds = [...workIds, ..._.cloneDeep(collection).works.splice(0, 4)];
    }

    const { data: works } = await queryWorks(
      {
        _id: {
          $in: workIds,
        },
      },
      1,
      workIds.length,
      { banner: 1 }
    );

    setCollections(
      _collections.map((c) => {
        // * Map works and their banners
        let _works = c.works.splice(0, 4).map((temp) => {
          const _ = works.find((w) => w._id === temp);

          return _;
        });

        c.works = _works;

        return c;
      })
    );
    setPageState(PAGE_STATE.IDLE);
  };

  const handleCollectionClick = (id) => {
    onView(id);
  };

  if (pageState !== PAGE_STATE.IDLE) {
    return (
      <div className="profile-collections">
        <div className="profile-collections-list">
          <div className="profile-collections-list-item">
            <ContentLoader width={"100%"} height={"244"}>
              <rect x="0" y="0" rx="8" ry="8" width="100%" height="100%" />
            </ContentLoader>
          </div>
          <div className="profile-collections-list-item">
            <ContentLoader width={"100%"} height={"244"}>
              <rect x="0" y="0" rx="8" ry="8" width="100%" height="100%" />
            </ContentLoader>
          </div>
          <div className="profile-collections-list-item">
            <ContentLoader width={"100%"} height={"244"}>
              <rect x="0" y="0" rx="8" ry="8" width="100%" height="100%" />
            </ContentLoader>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-collections">
      <div className="profile-collections-list">
        {collections.map(({ _id, name, works }) => {
          return (
            <div
              className="profile-collections-list-item"
              key={_id}
              onClick={() => handleCollectionClick(_id)}
            >
              <div className="profile-collections-list-item-preview">
                {works.map((work) => {
                  return (
                    <img
                      key={work?._id}
                      className="profile-collections-list-item-preview__banner"
                      alt="work-banner"
                      src={work.banner}
                    />
                  );
                })}
              </div>
              <span className="profile-collections-list-item__name">
                {name}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

List.propTypes = {};

export default List;
